import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { SuccessMsgUpdate } from "globalConstants";
import { getErrorMessage } from "helpers";
import { allMerchantService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseClaimCreditReviewMutationProps = {
	id: string;
};

const useClaimCreditReviewMutation = ({ onSuccessHandler }) => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: UseClaimCreditReviewMutationProps) => {
			dispatch(uiActions.showSpinnerOverlay());

			return allMerchantService.claimMerchant({
				id,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess(data, { id }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: `Assignee ${SuccessMsgUpdate}`,
					}),
				);
				onSuccessHandler?.(id);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useClaimCreditReviewMutation;
